import { omit } from "lodash";

import { formatValidQueryParamUrlCommaSeparated } from "utils/common";
import { formatProductCatalogOption } from "utils/products.utils";

import { emptySplitApi } from "./empty-split-api";
import {
  Product,
  ProductCatalogOption,
  ProductsFilters
} from "./types/products.type";

export const PRODUCT_CATALOG_QUERY =
  "{id,name,display_name,cpt_code{id,code},master_product{id,cpt_code{id,code},manufacturer,specification,model,type,subtype,description,is_active},price,supplier_price,component_price,is_active,managed_stock,loss_and_deductible_amount,max_discount,type,taxable,has_picture}";

export const PRODUCT_QUERY =
  "{id,name,display_name,master_product{id,cpt_code{id,code},manufacturer,specification,model,type,subtype,description,is_active},price,supplier_price,component_price,is_active,managed_stock,loss_and_deductible_amount,max_discount,cpt_code{id,code},type,taxable,has_picture}";

export const PRODUCTS_SEARCH_QUERY =
  "{id,name,display_name,specification,cpt_code{id,code},master_product{id,cpt_code{id,code},manufacturer,specification,model,type,subtype,description,is_active},price,supplier_price,component_price,is_active,loss_and_deductible_amount,max_discount,type,similarity,has_picture}";

// Adds Product.category to one of the product queries above; gated behind the
// productCategories flag because an older backend rejects the unknown field.
export const withProductCategory = (query: string, enabled: boolean) =>
  enabled ? `${query.slice(0, -1)},category}` : query;

// Same, for the product nested under every inventory_product{...} of a patient
// device query (the sale's own items{product{id}} is left alone).
export const withInventoryProductCategory = (
  query: string,
  enabled: boolean
) =>
  enabled
    ? query.replace(/(inventory_product\{[^{}]*\bproduct\{)/g, "$1category,")
    : query;

export const productsSearchApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getSearchProductCatalogOptions: builder.query<
      ProductCatalogOption[],
      ProductsFilters
    >({
      query: ({
        query = PRODUCTS_SEARCH_QUERY,
        search = "",
        threshold,
        ...filterParams
      }) =>
        `/products-search/?term=${encodeURIComponent(search)}&${formatValidQueryParamUrlCommaSeparated(
          omit(filterParams, ["limit", "query"])
        )}&threshold=${
          threshold ||
          (search.length < 2
            ? 0.1
            : search.length < 4
              ? 0.15
              : search.length < 6
                ? 0.2
                : 0.3)
        }&limit=300&query=${query}`,
      transformResponse: (response: Product[]) => {
        return formatProductCatalogOption(response);
      },
      providesTags: ["SearchProducts"]
    })
  })
});

export const { useGetSearchProductCatalogOptionsQuery } = productsSearchApi;
